// extracted by mini-css-extract-plugin
export var skipAnimation = "_12-0";